import React from "react";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";

type ErrorCodePageProps = {
  code: number;
  message: string;
};

function ErrorCodePage({ code, message }: ErrorCodePageProps) {
  return (
    <div className={styles.container}>
      <div className={styles.errorCode}>{code}</div>
      <div className={styles.text}>{message}</div>
      <div className={styles.returnText}>
        <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
          Return To Home
        </Link>
      </div>
    </div>
  );
}

export default ErrorCodePage;
